import { render, staticRenderFns } from "./Vsim.vue?vue&type=template&id=8cb09832&scoped=true&"
import script from "./Vsim.vue?vue&type=script&lang=js&"
export * from "./Vsim.vue?vue&type=script&lang=js&"
import style0 from "./Vsim.vue?vue&type=style&index=0&id=8cb09832&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb09832",
  null
  
)

export default component.exports